<template>
  <div class="auth-wrapper auth-v2">
    <ParticleAnimation />

    <div class="auth-left" ref="authParentBox">
      <div class="auth-box" ref="authChildBox">
        <b-link class="">
          <img
            src="@/assets/images/svg/logo.svg"
            style="width: 270px; padding-top: 8px"
          />
        </b-link>
        <img src="@/assets/images/login_logo.png" class="teeth" alt="" />
        <img src="@/assets/images/svg/vector.png" class="vectors" alt="" />
        <p>
          {{ $t("efficiencyQuality") }} -<br />{{
            $t("aiRevolutionize")
          }}!
        </p>
      </div>
    </div>
    <div class="auth-right">
      <div class="language-dropdown">
        <ul>
          <Language/>
        </ul>
       </div>
      <div class="auth-detail">
        <div class="auth-detail-logo">
          <h2>{{ $t("welcome") }}</h2>
        </div>
        <p>
          {{
            $t(
              "futureOfDentistry"
            )
          }}
        </p>
        <h3 class="text-center">{{ $t("pleaseLogin") }}</h3>

        <!-- form -->
        <validation-observer ref="loginValidation">
            <b-form class="auth-login-form mt-2" @submit.prevent>
              <!-- email -->
              <label for="login-password"> {{ $t("email") }} </label>
              <b-form-group label-for="login-email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password"> {{ $t("password") }} </label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                @click="validationForm"
              >
                {{ $t("signIn") }}
              </b-button>
            </b-form>
          </validation-observer>
        <div style="clear: both"></div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import ParticleAnimation from "@/components/ParticleAnimation.vue";
import Language from "@/components/Language.vue";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import AuthService from "../services/auth.service";
import NotificationService from "../services/notification.service";
import { getBrowserLanguage } from "@/utils/browserLanguage";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    ParticleAnimation,
    Language
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: "",
      password: "",
      userEmail: "",
      sideImg: require("@/assets/images/pages/login/login.png"),
      // validation rulesimport store from '@/store/index'
      required,
      email,
    };
  },
  async beforeCreate() {
    
    if (!localStorage.getItem('lang')) {
      const browserLang = getBrowserLanguage();
      const supportedLanguages = ['en', 'de', 'fr', 'es', 'tu'];
      
      if (supportedLanguages.includes(browserLang)) {
        this.$i18n.locale = browserLang;
        localStorage.setItem('lang', browserLang);
        document.documentElement.lang = browserLang;
      } else {
        this.$i18n.locale = 'en';
        localStorage.setItem('lang', 'en');
        document.documentElement.lang = 'en';
      }
    }

    const token = localStorage.getItem("token");
    if (token) this.$router.push({ name: "home" });
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      this.sideImg = require("@/assets/images/pages/login/login.png");
      return this.sideImg;
    },
  },
  mounted() {
    this.setWidth();
    window.addEventListener("resize", this.setWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setWidth);
  },
  methods: {
    async validationForm() {
      this.$refs.loginValidation.validate().then(async (success) => {
        if (success) {
          try {
            this.$store.commit("showLoader", true);
            let response = await this.$store.dispatch("auth/login", {
              mail: this.userEmail,
              password: this.password,
            });
            const userId = response?.data?.token_info?.user_id;
            this.$store.commit("auth/set_authenticated", true);
            localStorage.setItem(
              "user",
              JSON.stringify(response.data.user) ?? "{}"
            );
            localStorage.setItem("authenticated", true);
            this.$router.push({ name: "home" });
          } catch (err) {
          } finally {
            this.$store.commit("showLoader", false);
          }
        }
      });
    },
    setWidth() {
      const parent = this.$refs.authParentBox;
      const child = this.$refs.authChildBox;
      if (!parent || !child) return;
      child.style.width = `${parent.offsetWidth}px`;
      child.style.height = `${parent.offsetHeight}px`;
    },
  },
  
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
